import { BuyCard, } from "./BuyCard";	
import { RedeemCard, } from "./RedeemCard";
import { useSwap, } from "@store";
import { raise, } from "@utils";


/**
 * A component that renders either the BuyCard or RedeemCard based on the current swap mode.
 * The component uses the useSwap hook to determine which card to display.
 * 
 * @component
 * @returns {JSX.Element} Either the BuyCard or RedeemCard component based on the current mode
 * @throws {Error} If the mode is neither "BUY" nor "REDEEM"
 */
export const SwapCards = () => {
	const {
		mode,
	} = useSwap();

	return (
		mode === "REDEEM" ? <RedeemCard /> :
		mode === "BUY" ? <BuyCard /> :
		raise("Invalid mode")
	);
};
